import { EmailTemplateForm } from "../EmailTemplateForm";

export const AddEmailTemplate = () => {
  return <EmailTemplateForm />;
};
